import { createContext } from "react";

export const ReturnContext = createContext({});